"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FiConnectEventCompleteStatus = exports.FiConnectEventTypes = exports.Routes = exports.Region = void 0;
// TODO: Keep these imports relative so that types work in consuming Host Apps - https://di.latitudefinancial.com/jira/browse/NZP-530
var Region;
exports.Region = Region;

(function (Region) {
  Region["NZ"] = "nz";
  Region["AU"] = "au";
  Region["ALL"] = "";
})(Region || (exports.Region = Region = {}));

var Routes;
exports.Routes = Routes;

(function (Routes) {
  Routes["init"] = "/";
  Routes["institutions"] = "/institutions";
  Routes["login"] = "/login";
  Routes["mfa"] = "/mfa";
  Routes["accounts"] = "/accounts";
  Routes["income"] = "/income";
})(Routes || (exports.Routes = Routes = {}));

var FiConnectEventTypes;
exports.FiConnectEventTypes = FiConnectEventTypes;

(function (FiConnectEventTypes) {
  FiConnectEventTypes["COMPLETE"] = "COMPLETE";
  FiConnectEventTypes["ERROR"] = "ERROR";
  FiConnectEventTypes["ANALYTICS"] = "ANALYTICS";
  FiConnectEventTypes["RESET"] = "RESET";
})(FiConnectEventTypes || (exports.FiConnectEventTypes = FiConnectEventTypes = {}));

var FiConnectEventCompleteStatus;
exports.FiConnectEventCompleteStatus = FiConnectEventCompleteStatus;

(function (FiConnectEventCompleteStatus) {
  FiConnectEventCompleteStatus["INCOME_SELECTED"] = "income-selected";
  FiConnectEventCompleteStatus["NO_INCOME_SELECTED"] = "no-income-selected";
  FiConnectEventCompleteStatus["NO_INCOME_FOUND"] = "no-income-found";
})(FiConnectEventCompleteStatus || (exports.FiConnectEventCompleteStatus = FiConnectEventCompleteStatus = {}));